import React, { useState } from "react";
import { useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../Context";

export default function Contact() {
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [parent, setParent] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");

  const { setNav } = useGlobalContext();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    setNav(false);
    document.title = "Beyond Limits Football Academy - Contact-Us";
  }, [setNav]);

  // console.log(`${window.location.host}/players`);

  const submit = async () => {
    if (!fname && !lname && !comment && email) {
      return;
    }
    await fetch(`https://formsubmit.co/ajax/info@beyondlimitsfa.com`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        PlayersFirstName: `${fname}`,
        PlayersLastName: `${lname}`,
        ParentPhone: `${parent}`,
        ParentEmail: `${email}`,
        message: `${comment}`,
      }),
    })
      .then((res) => console.log(res.json()))
      .then((data) => navigate("/thank-you"))
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="container">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <p className="Players__title">contact us</p>
        </div>
      </div>
      <form className="Form">
        <div className="container">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <p className="Players__title">Contact form</p>
          </div>
          <div className="row">
            <div className="col-md-6 Form__group">
              <input
                className="text-input"
                type="text"
                placeholder="Player's first name *"
                onChange={(e) => setFname(e.currentTarget.value)}
                name="Player's first name"
                required
                value={fname}
              />
            </div>
            <div className="col-md-6 Form__group">
              <input
                className="text-input"
                type="text"
                placeholder="Player's last name *"
                onChange={(e) => setLname(e.currentTarget.value)}
                required
                name="Player's last name"
                value={lname}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 Form__group">
              <input
                className="text-input"
                type="text"
                placeholder="Parent Email *"
                onChange={(e) => setEmail(e.currentTarget.value)}
                required
                name="Parent Email"
                value={email}
              />
            </div>
            <div className="col-md-6 Form__group">
              <input
                className="text-input"
                type="text"
                placeholder="Parent Phone"
                onChange={(e) => setParent(e.currentTarget.value)}
                name="Parent Phone"
                value={parent}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 Form__group">
              <textarea
                placeholder="Comments or Questions *"
                name="Message"
                id=""
                cols="30"
                rows="10"
                required
                value={comment}
                onChange={(e) => setComment(e.currentTarget.value)}
              />
            </div>
          </div>
          <label htmlFor="check" style={{ fontSize: "1.8rem" }}>
            <input
              type="checkbox"
              name="check"
              id="check"
              style={{ marginRight: "5px" }}
              required
            />
            I have read and agree to the Privacy Policy regarding the processing
            of personal information, as well as all of the terms. *
          </label>
          {/* <input
            type="hidden"
            name="_next"
            value={`${window.location.host}/players`}
          /> */}
          <input
            type="submit"
            value="submit"
            className="Form__submit"
            onClick={(e) => {
              e.preventDefault();
              submit(fname, comment);
            }}
          />
        </div>
      </form>
    </>
  );
}
